/**
 * @flow
 * @relayHash 92b48f3004797668e9b898d8df6862c9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PropertyWhere = {|
  and?: ?$ReadOnlyArray<?PropertyWhere>,
  or?: ?$ReadOnlyArray<?PropertyWhere>,
  id?: ?ConditionInputType,
  code?: ?ConditionInputType,
  name?: ?ConditionInputType,
  address?: ?ConditionInputType,
  lnglat?: ?ConditionInputType,
  type?: ?ConditionInputType,
  status?: ?ConditionInputType,
  leaseType?: ?ConditionInputType,
  description?: ?ConditionInputType,
  managerId?: ?ConditionInputType,
  locationId?: ?ConditionInputType,
  createdAt?: ?ConditionInputType,
  createdBy?: ?ConditionInputType,
  updatedAt?: ?ConditionInputType,
  updatedBy?: ?ConditionInputType,
  sensors?: ?ConditionInputType,
  photoUrl?: ?ConditionInputType,
|};
export type ConditionInputType = {|
  eq?: ?string,
  ne?: ?string,
  gt?: ?string,
  gte?: ?string,
  lt?: ?string,
  lte?: ?string,
  is?: ?string,
  not?: ?string,
  in?: ?$ReadOnlyArray<?string>,
  notIn?: ?$ReadOnlyArray<?string>,
  like?: ?string,
  notLike?: ?string,
  iLike?: ?string,
  insub?: ?string,
|};
export type PropertySelectQueryVariables = {|
  where?: ?PropertyWhere
|};
export type PropertySelectQueryResponse = {|
  +properties: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
        +location: ?{|
          +name: string
        |},
      |}
    |}>
  |}
|};
export type PropertySelectQuery = {|
  variables: PropertySelectQueryVariables,
  response: PropertySelectQueryResponse,
|};
*/


/*
query PropertySelectQuery(
  $where: PropertyWhere
) {
  properties(where: $where, first: 10, orderBy: [name], order: ASC) {
    edges {
      node {
        id
        name
        location {
          name
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "where",
    "type": "PropertyWhere",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "order",
    "value": "ASC"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "name"
    ]
  },
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PropertySelectQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "properties",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "PropertyConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PropertyEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Property",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "location",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Location",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PropertySelectQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "properties",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "PropertyConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "PropertyEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Property",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "location",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Location",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PropertySelectQuery",
    "id": null,
    "text": "query PropertySelectQuery(\n  $where: PropertyWhere\n) {\n  properties(where: $where, first: 10, orderBy: [name], order: ASC) {\n    edges {\n      node {\n        id\n        name\n        location {\n          name\n          id\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f47a93aa73eace201e887897d2fb6dc5';
module.exports = node;
